import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectedSecondary", "selectedLongTail", "customSecondaryInput", "customLongTailInput", "customSecondaryList", "customLongTailList"]

  toggle(event) {
    const pill = event.currentTarget
    const selected = pill.dataset.selected === "true"
    const hiddenInput = pill.querySelector("input[type=hidden]")

    if (selected) {
      pill.dataset.selected = "false"
      pill.classList.remove("bg-indigo-100", "text-indigo-700", "ring-1", "ring-indigo-300")
      pill.classList.add("bg-gray-100", "text-gray-500", "line-through")
      if (hiddenInput) hiddenInput.disabled = true
    } else {
      pill.dataset.selected = "true"
      pill.classList.remove("bg-gray-100", "text-gray-500", "line-through")
      pill.classList.add("bg-indigo-100", "text-indigo-700", "ring-1", "ring-indigo-300")
      if (hiddenInput) hiddenInput.disabled = false
    }
  }

  addCustomSecondary(event) {
    if (event.type === "keydown" && event.key !== "Enter") return
    event.preventDefault()

    const input = this.customSecondaryInputTarget
    const value = input.value.trim()
    if (!value) return

    this.appendCustomPill(this.customSecondaryListTarget, value, "custom_secondary")
    input.value = ""
  }

  addCustomLongTail(event) {
    if (event.type === "keydown" && event.key !== "Enter") return
    event.preventDefault()

    const input = this.customLongTailInputTarget
    const value = input.value.trim()
    if (!value) return

    this.appendCustomPill(this.customLongTailListTarget, value, "custom_long_tail")
    input.value = ""
  }

  removeCustom(event) {
    event.currentTarget.closest("[data-custom-pill]").remove()
  }

  appendCustomPill(container, value, fieldName) {
    const pill = document.createElement("span")
    pill.dataset.customPill = "true"
    pill.className = "inline-flex items-center gap-1 rounded-full bg-green-100 text-green-700 ring-1 ring-green-300 px-2.5 py-0.5 text-xs font-medium"
    pill.innerHTML = `
      ${this.escapeHtml(value)}
      <input type="hidden" name="${fieldName}[]" value="${this.escapeHtml(value)}">
      <button type="button" data-action="click->seo-keywords#removeCustom" class="ml-0.5 text-green-500 hover:text-red-500 cursor-pointer">&times;</button>
    `
    container.appendChild(pill)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
